import { Module } from 'vuex'
import user from './user'
import { enableResetStore } from '@/store'

const userStores: Record<string, Module<any, any>> = { user: enableResetStore(user) }

export default userStores
